const lodash = require('lodash')
const { createReducer } = require('../../helpers')
const {
  GET_CARTS,
  GET_CARTS_SUCCESS,
  GET_CARTS_ERROR,
  GET_CARTS_RESET,

  GET_CARTS_COUNT,
  GET_CARTS_COUNT_SUCCESS,
  GET_CARTS_COUNT_ERROR,
  GET_CARTS_COUNT_RESET,

  CREATE_CART,
  CREATE_CART_SUCCESS,
  CREATE_CART_ERROR,
  CREATE_CART_RESET,

  DELETE_CART,
  DELETE_CART_SUCCESS,
  DELETE_CART_ERROR,
  DELETE_CART_RESET,

  REORDER,
  REORDER_SUCCESS,
  REORDER_ERROR,
  REORDER_RESET,

  CREATE_SERVICES_CART,
  CREATE_SERVICES_CART_SUCCESS,
  CREATE_SERVICES_CART_ERROR,
  CREATE_SERVICES_CART_RESET,

  GET_SERVICES_CARTS,
  GET_SERVICES_CARTS_SUCCESS,
  GET_SERVICES_CARTS_ERROR,
  GET_SERVICES_CARTS_RESET,
} = require('./constants')

const initialState = {
  cart: {
    data: {},
    loading: false,
    error: false,
  },
  servicesCart: {
    data: {},
    loading: false,
    error: false,
  },
  count: {
    data: {},
    loading: false,
    error: false,
  },
  create: {
    data: {},
    loading: false,
    error: false,
  },
  servicesCreate: {
    data: {},
    loading: false,
    error: false,
  },
  del: {
    data: {},
    loading: false,
    error: false,
  },
  reOrder: {
    data: {},
    loading: false,
    error: false,
  },
}

module.exports = createReducer(
  {
    ///----------------------GET CARTS---------------------------///
    [GET_CARTS]: (draft) => ({
      cart: {
        ...draft.cart,
        loading: true,
      },
    }),
    [GET_CARTS_SUCCESS]: (draft, action) => ({
      cart: {
        ...draft.cart,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_CARTS_ERROR]: (draft, action) => ({
      cart: {
        ...draft.cart,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_CARTS_RESET]: () => ({
      cart: { ...initialState.cart },
    }),

    ///----------------------GET SERVICES CART---------------------------///
    [GET_SERVICES_CARTS]: (draft) => ({
      servicesCart: {
        ...draft.servicesCart,
        loading: true,
      },
    }),
    [GET_SERVICES_CARTS_SUCCESS]: (draft, action) => ({
      servicesCart: {
        ...draft.servicesCart,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_SERVICES_CARTS_ERROR]: (draft, action) => ({
      servicesCart: {
        ...draft.servicesCart,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_SERVICES_CARTS_RESET]: () => ({
      servicesCart: { ...initialState.servicesCart },
    }),
    ///----------------------GET CARTS COUNT-------------------------///
    [GET_CARTS_COUNT]: (draft) => ({
      count: {
        ...draft.count,
        loading: true,
      },
    }),
    [GET_CARTS_COUNT_SUCCESS]: (draft, action) => ({
      count: {
        ...draft.count,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_CARTS_COUNT_ERROR]: (draft, action) => ({
      count: {
        ...draft.count,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_CARTS_COUNT_RESET]: () => ({
      count: { ...initialState.count },
    }),
    ///-----------------------CREATE CARTS-----------------------///
    [CREATE_CART]: (draft) => ({
      create: {
        ...draft.create,
        loading: true,
      },
    }),
    [CREATE_CART_SUCCESS]: (draft, action) => ({
      create: {
        ...draft.create,
        loading: false,
        data: action.payload.data,
      },
    }),
    [CREATE_CART_ERROR]: (draft, action) => ({
      create: {
        ...draft.create,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CREATE_CART_RESET]: () => ({
      create: { ...initialState.create },
    }),

    ///-----------------------CREATE SERVICES CARTS-----------------------///
    [CREATE_SERVICES_CART]: (draft) => ({
      servicesCreate: {
        ...draft.servicesCreate,
        loading: true,
      },
    }),
    [CREATE_SERVICES_CART_SUCCESS]: (draft, action) => ({
      servicesCreate: {
        ...draft.servicesCreate,
        loading: false,
        data: action.payload.data,
      },
    }),
    [CREATE_SERVICES_CART_ERROR]: (draft, action) => ({
      servicesCreate: {
        ...draft.servicesCreate,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CREATE_SERVICES_CART_RESET]: () => ({
      servicesCreate: { ...initialState.servicesCreate },
    }),
    ///-----------------------DELETE CARTS-----------------------///
    [DELETE_CART]: (draft) => ({
      del: {
        ...draft.del,
        loading: true,
      },
    }),
    [DELETE_CART_SUCCESS]: (draft, action) => ({
      del: {
        ...draft.del,
        loading: false,
        data: action.payload.data,
      },
    }),
    [DELETE_CART_ERROR]: (draft, action) => ({
      del: {
        ...draft.del,
        loading: false,
        error: action.payload.error,
      },
    }),
    [DELETE_CART_RESET]: () => ({
      del: { ...initialState.del },
    }),

    [REORDER]: (draft) => ({
      reOrder: {
        ...draft.reOrder,
        loading: true,
      },
    }),
    [REORDER_SUCCESS]: (draft, action) => ({
      reOrder: {
        ...draft.reOrder,
        loading: false,
        data: action.payload.data,
      },
    }),
    [REORDER_ERROR]: (draft, action) => ({
      reOrder: {
        ...draft.reOrder,
        loading: false,
        error: action.payload.error,
      },
    }),
    [REORDER_RESET]: () => ({
      reOrder: { ...initialState.reOrder },
    }),
  },
  initialState,
)
